import cn from "classnames";
import { Close as CloseIcon } from "@rshbintech.dboul/icons";
import { DialogButton } from "../dialog-button";
import { DialogBaseProps } from "./types";
import styles from "./styles.module.scss";

export const DialogBase = ({
  children,
  className,
  size = "small",
  showCloseIcon,
  dataTestId,
  onClose,
}: DialogBaseProps) => (
  <div
    className={cn(className, styles.dialog, styles[size])}
    data-test-id={`${dataTestId}-content`}
  >
    {showCloseIcon && (
      <DialogButton
        className={styles["close-button"]}
        dataTestId={`${dataTestId}-close-button`}
        onClick={onClose}
      >
        <CloseIcon size="medium" />
      </DialogButton>
    )}
    {children}
  </div>
);
